import { lazy } from 'react'

import { BrokerBuyLinks } from '@/enums/brokerBuySteps'

export const BrokerBuyRouter = {
  step1: {
    element: lazy(() => import('@/steps/CommercialCombined/Step1')),
    href: BrokerBuyLinks.Step1,
  },
  step2: {
    element: lazy(() => import('@/steps/CommercialCombined/Step2')),
    href: BrokerBuyLinks.Step2,
  },
  step3: {
    element: lazy(() => import('@/steps/CommercialCombined/Step3')),
    href: BrokerBuyLinks.Step3,
  },
  step4: {
    element: lazy(() => import('@/steps/CommercialCombined/Step4')),
    href: BrokerBuyLinks.Step4,
  },
  step5: {
    element: lazy(() => import('@/steps/CommercialCombined/Step5')),
    href: BrokerBuyLinks.Step5,
  },
  step6: {
    element: lazy(() => import('@/steps/CommercialCombined/Step6')),
    href: BrokerBuyLinks.Step6,
  },
  step7: {
    element: lazy(() => import('@/steps/CommercialCombined/Step7')),
    href: BrokerBuyLinks.Step7,
  },
  step8: {
    element: lazy(() => import('@/steps/CommercialCombined/Step8')),
    href: BrokerBuyLinks.Step8,
  },
  step9: {
    element: lazy(() => import('@/steps/CommercialCombined/Step9')),
    href: BrokerBuyLinks.Step9,
  },
  step10: {
    element: lazy(() => import('@/steps/CommercialCombined/Step10')),
    href: BrokerBuyLinks.Step10,
  },
  step11: {
    element: lazy(() => import('@/steps/CommercialCombined/Step11')),
    href: BrokerBuyLinks.Step11,
  },
  step12: {
    element: lazy(() => import('@/steps/CommercialCombined/Step12')),
    href: BrokerBuyLinks.Step12,
  },
  step13: {
    element: lazy(() => import('@/steps/CommercialCombined/Step13')),
    href: BrokerBuyLinks.Step13,
  },
  step14: {
    element: lazy(() => import('@/steps/CommercialCombined/Step14')),
    href: BrokerBuyLinks.Step14,
  },
  step15: {
    element: lazy(() => import('@/steps/CommercialCombined/Step15')),
    href: BrokerBuyLinks.Step15,
  },
  step16: {
    element: lazy(() => import('@/steps/CommercialCombined/Step16')),
    href: BrokerBuyLinks.Step16,
  },
  step17: {
    element: lazy(() => import('@/steps/CommercialCombined/Step17')),
    href: BrokerBuyLinks.Step17,
  },
  step18: {
    element: lazy(() => import('@/steps/CommercialCombined/Step18')),
    href: BrokerBuyLinks.Step18,
  },
  step19: {
    element: lazy(() => import('@/steps/CommercialCombined/Step19')),
    href: BrokerBuyLinks.Step19,
  },
  step20: {
    element: lazy(() => import('@/steps/CommercialCombined/Step20')),
    href: BrokerBuyLinks.Step20,
  },
  step21: {
    element: lazy(() => import('@/steps/CommercialCombined/Step21')),
    href: BrokerBuyLinks.Step21,
  },
  step22: {
    element: lazy(() => import('@/steps/CommercialCombined/Step22')),
    href: BrokerBuyLinks.Step22,
  },
  step23: {
    element: lazy(() => import('@/steps/CommercialCombined/Step23')),
    href: BrokerBuyLinks.Step23,
  },
  step24: {
    element: lazy(() => import('@/steps/CommercialCombined/Step24')),
    href: BrokerBuyLinks.Step24,
  },
  step25: {
    element: lazy(() => import('@/steps/CommercialCombined/Step25')),
    href: BrokerBuyLinks.Step25,
  },
  step26: {
    element: lazy(() => import('@/steps/CommercialCombined/Step26')),
    href: BrokerBuyLinks.Step26,
  },
  step27: {
    element: lazy(() => import('@/steps/CommercialCombined/Step27')),
    href: BrokerBuyLinks.Step27,
  },
}
